export enum EntityStoreKey {
  TellentMembers = 'TellentMembers',
  TellentApps = 'TellentApps',
}

export type TransferOwnershipPayload = {
  memberGuid: string;
  code: string;
};

export const MEMBER_LISTED_ONLY = 'member_listed_only';
